import { getFeature } from 'Cloud/Application/FeaturesEs6';

export const mspProIframeBaseProductId = getFeature('msp_pro_iframe_base_product_id') || 'W128GB_1m_mail_space_pro_force_trial';
export const mspProIframeTitle = getFeature('msp_pro_iframe_title') || `Оплата тарифа Mail Space PRO для бизнеса`;
